import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { InsertEventRequest } from "./InsertEventRequest";
import { ScheduleEventRequest } from "./ScheduleEventRequest";
import { UpdateEventRequest } from "./UpdateEventRequest";
import { UpdateScheduleRequest } from "./UpdateScheduleRequest";

@Injectable()
export class DataService_DefineEvents {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	C9EventAndScheduleGetList(SchoolID, StartDate, EndDate, Active) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9EventAndScheduleGetList?SchoolID=" + SchoolID + "&StartDate=" + StartDate + "&EndDate=" + EndDate + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9DefineEventInsert(parms: InsertEventRequest) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9DefineEventInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9ScheduleInsert(parms: ScheduleEventRequest) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9ScheduleInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9EventInUse(EventID) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9EventInUse?EventID=" + EventID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9DeleteEvent(EventID) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9DeleteEvent?EventID=" + EventID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9ScheduleDelete(ScheduleID) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9ScheduleDelete?ScheduleID=" + ScheduleID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DefineEventSetActive(EventID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "EventAlert/DefineEventSetActive?EventID=" + EventID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9ScheduleSetActive(ScheduleID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9ScheduleSetActive?ScheduleID=" + ScheduleID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	C9ScheduleGet(ScheduleID) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9ScheduleGet?ScheduleID=" + ScheduleID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9DefineEventGet(EventID) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9DefineEventGet?EventID=" + EventID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9DefineEventUpdate(parms: UpdateEventRequest) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9DefineEventUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	C9ScheduleUpdate(parms: UpdateScheduleRequest) {
		var postResult$ = new Subject();
		var url = "EventAlert/C9ScheduleUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
